import { createStore } from "redux";

// 导入reducer

import  { reducer } from "../reducer";


export default createStore(reducer)